const DefaultData = {
     APISERVERURL: 'https://b2cclienttravel.azurewebsites.net/api/',
    APILOCALURL: 'http://localhost:5126/api/',
    APIACTIVEURL: 'https://b2cclienttravel.azurewebsites.net/api/',
    TENANTID: 'landairtravels',
    DEFAULTCOMPANYID: '8963A534-24A3-45A8-94F1-6C0573B8A9CF',
    DEFAULTBRANCHID: '6FC3B732-D2EB-4AB1-A516-D332E60BEC5B',
    DEFAULTCURRENCY: 'INR',
    WEBSITE:'https://landairtravels.com',
    DEFAULTCOMPANYEMAIL: 'support@landairtravels.com',
    DEFAULTCOMPANYPHONENUMBER: '7995331116',
    DEFAULTCOMPANYGST: '36AAWCS4809A1Z6',
    DEFAULTCOMPANYNAME: 'LAND AIR TRAVELS PVT LTD',
    DEFAULTBRANDNAME: 'LAND AIR TRAVELS',
    DEFAULTCOMPANYADDRESS:'GF-3, Tourism Plaza, 6-3-869/A,Greenlands, Begumpet,Hyderabad, Telangana 500016',
    FACEBOOKURL:'https://www.facebook.com/landair',
    TWITTERURL:'https://x.com/landair',
    INSTGRAMURL:'https://www.instagram.com/landair',
    THEMECOLOR1:"#031B34",
    THEMECOLOR2:"#BB2D3B",
    THEMECOLOR3:"#ffffff",
    LANDINGPAGETITLE:"Leading the Evolution of Travel Booking",
    LANDINGPAGESUBTITLE:"Complete Solution for Your Travel Business",
    FOOTERCOPYRIGHTS: "1974 - 2025 Land Air Travels.",
    FOOTERSUBTITLE: "We make your dream more beautiful & enjoyable with lots of happiness.",
    COMPANYTYPE: "AGENT",
    USERTYPE: "AGENT",
    PLANTYPE:"CUSTOM"
};

export default DefaultData;